import React from 'react'
import {useQuery} from '@apollo/react-hooks'
import gql from 'graphql-tag'
import {Link} from 'react-router-dom'
import {Button} from '../common/bootstrap'

import {formatDate} from '@prepler/core/lib/constants/dateTime'
import routesHelper from '@prepler/core/lib/routesHelper'

import Loader from '../common/loader'
import GraphqlError from '../dev/graphqlError'
import withParams from '../common/withParams'
import Pagination from '../common/pagination'
import Markdown from '../common/markdown'
import Helmet from '../common/helmet'
import StickyTitle from '../common/stickyTitle'
import useStyles from './styles'

const ARTICLES = gql`
	query Articles($page: Int) {
		articlesPaginated(page: $page) {
			paginationMeta {
				totalPages
				...PaginationPaginationMeta
			}
			articles {
				id
				slug
				authorName
				date
				photo {
					medium
					medium2
					medium4
				}
				teaser
				title
			}
		}
	}
	${Pagination.fragments.paginationMeta}
`;

const ArticlesList = ({params, setParams}) => {
	const classes = useStyles();
	const page = parseInt(params.page);
	const {loading, error, data} = useQuery(ARTICLES, {variables: {page}, context: {authPublic: true}});

	if (loading) return <Loader/>;
	if (error) return <GraphqlError error={error}/>;

	const {articlesPaginated: {articles, paginationMeta: meta}} = data;

	return (
		<StickyTitle title={<Link to={{pathname: routesHelper.articlesPath()}}>Blog</Link>}>
			<Helmet canonical={routesHelper.articlesUrl()} titleTemplate={`%s ${page && page > 1 ? `- Page ${page} ` : ''}| Prepler`}/>
			{articles.map(({id, slug, authorName, date, photo, teaser, title}) => (
				<article key={id} className={classes.article}>
					<div className={classes.header}>
						<h2 className={classes.title}>
							<Link to={routesHelper.articlePath({id: slug || id})}>{title}</Link>
						</h2>
						<div className={classes.articleInfo}>
							<time pubdate className={classes.date}>{formatDate(date)}</time>
							{authorName && <span className={classes.author}>by {authorName}</span>}
						</div>
					</div>
					<div className={classes.content}>
						<div className={classes.picture}>
							<Link to={routesHelper.articlePath({id: slug || id})}>
								<img
									alt="" src={photo.medium}
									srcSet={`${photo.medium} 1920w, ${photo.medium2} 960w, ${photo.medium4} 480w`}
								/>
							</Link>
						</div>
						<div className={classes.markdown}>
							<Markdown text={teaser}/>
							<div style={{display: 'block', width: '100%', float: 'right'}}>
								<Link to={routesHelper.articlePath({id: slug || id})} className={classes.readMore}>
									<Button bsStyle="default" bsSize="small">Read More</Button>
								</Link>
							</div>
							<div style={{clear: 'both'}}/>
						</div>
					</div>
				</article>
			))}
			{meta.totalPages > 1 && (
				<center>
					<Pagination
						params={params} setParams={setParams}
						meta={meta} style={{}}
						canonicalUrl={routesHelper.articlesUrl}
					/>
				</center>
			)}
		</StickyTitle>
	);
};

export default withParams(ArticlesList);
